// Demo home gate.
//
// SECOND-FACE FALLBACK — replaces the real `/` (HomePage) for one
// specific demo account so we can show "Platonica at peak performance"
// in pitch meetings without depending on real seeded data.
//
// REPLACE LATER: when the demo account is decommissioned (or the real
// home dashboard reaches feature parity), delete this file, the
// features/home-demo/ folder, and the `<HomeRouter>` switch in App.tsx.

export const DEMO_HOME_EMAIL = "admin@platonica.io"

export function isDemoHomeAccount(email: string | undefined | null): boolean {
  if (!email) return false
  return email.toLowerCase() === DEMO_HOME_EMAIL
}
